export default __webpack_public_path__ + "edf2e148c06af969d07b53fd4133e45b.png";